export const ButtonStyle = {
        primary: "bg-blue-300 hover:bg-blue-500 hover:border-transparent text-black font-bold rounded-xs",
        secondary: "hover:bg-blue-500 hover:bg-blue-700 hover:border-transparent text-white font-bold rounded-xs",
        basic: "bg-white hover:bg-gray-700 text-gray-700 font-bold rounded-xs",
        delete: "bg-red-300 hover:bg-red-500 text-black font-bold rounded-xs"
};

export const ButtonSize = {
        sm: "w-16 text-xs",
        lg: "w-32 text-base"
}

export const ModalSize = {
        sm: "max-w-sm",
        md: "max-w-md min-h-auto",
        lg: "max-w-2xl min-h-auto",
        custom: "max-w-md",
}
